import React from 'react';

import styled from 'styled-components';

import { useCommunityViewContext } from 'components/View/CommunityViewContext';

import { formatValueDifference, getDifferenceColor } from './valueDifferenceUtils';

const DifferenceText = styled.span<{ color: string }>`
  color: ${({ color }) => color};
  margin-left: 4px;
`;

type Props = {
  difference?: number | null;
  widgetType: number;
  valueDisplay?: number;
  prefix?: string;
  className?: string;
};

const ValueDifference = ({ difference, widgetType, valueDisplay, prefix = '', className }: Props) => {
  const { community } = useCommunityViewContext();
  const formattedDifference = formatValueDifference(difference ?? null, widgetType, valueDisplay, community);

  if (!formattedDifference) {
    return null;
  }

  return (
    <DifferenceText className={className} color={getDifferenceColor(difference ?? 0, widgetType)}>
      {prefix}
      {formattedDifference}
    </DifferenceText>
  );
};

export default ValueDifference;
